<template>
  <div>
    <v-card flat tile>
      <v-card-text class="pl-0 mt-4 pt-0">
        <v-col class="pb-0 pt-0 pl-0">
          <p class="mt-0 mb-0 title font-weight-light font-weight-bold">엑셀 상품 등록하기</p>
          <p
            class="mt-2 mb-0 subtitle-2 font-weight-medium"
          >정품인증서비스에서 관리하실 상품의 정보를 엑셀로 일괄 업로드할 수 있습니다.</p>
        </v-col>

        <div>
          <v-row class="mb-1 col-8 pl-0">
            <v-col class="d-inline-block pl-0 pr-0" cols="7" height="50px">
              <v-file-input
                chips
                label="클릭하여 엑셀 파일을 업로드해주세요."
                class="pt-1 pl-1"
                v-model="excelFile"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              ></v-file-input>
            </v-col>
            <v-col class="d-inline-block pl-0" height="50px">
              <v-btn depressed color="black white--text ml-5" large @click.prevent="readFile">업로드하기</v-btn>
            </v-col>
          </v-row>
        </div>

        <div>
          <p class="mb-0 body-2 font-weight-light mt-1 black--text">아래의 엑셀 파일 양식에 맞게 입력하여 등록해주세요.</p>
          <p
            class="mb-0 body-2 font-weight-light black--text"
          >※ 엑셀 파일의 형식은 .xls .xlsx / 파일 용량은 최대 10MB - 큰 용량일 경우 나누어 업로드합니다.</p>

          <v-btn
            depressed
            color="teal"
            class="mt-3 white--text mb-0"
            @click.prevent="excelSampleDownLoad"
          >엑셀업로드 양식 다운로드</v-btn>
        </div>

        <div class="col-12 pl-0 pb-0" v-if="failSheetData.length > 0">
          <div class="pt-0 pb-0 pl-0 pt-3">
            <strong class="mb-0 body-2 font-weight-blod black--text pt-0 pb-0 mt-0">
              [총
              <font class="font-weight-bold">{{ sheet.totalCount | numberFormat }}</font>개 -
              <font class="font-weight-bold">
                {{
                (sheet.totalCount - failSheetData.length) | numberFormat
                }}
              </font>개 정상 /
              <font class="font-weight-bold">{{ failSheetData.length | numberFormat }}</font>개 실패] 업로드한 상품 중 실패된 정보를 확인하시고
              재등록해주세요.
            </strong>
          </div>
        </div>

        <v-card class="col-12 col-md-12 mt-2 mb-4 pt-0 pb-0" v-if="failSheetData.length > 0">
          <v-data-table
            :headers="headersAddList"
            :items="failSheetData"
            :items-per-page="20"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, 50],
              'items-per-page-text': '목록 노출 수 선택:',
            }"
          >
            <template v-slot:item.product_info="{ item }" class="pl-0 pr-0 ml-0 mr-0">
              <v-row no-gutters>
                <v-col :cols="11" class="pl-0 pr-0 ml-0 mr-0">
                  <p
                    class="mb-0 mt-3 mr-0 text-left text-truncate caption"
                  >상품명 : {{ item.product_name }}</p>
                  <p class="mb-0 mr-0 text-left text-truncate caption">품목명 : {{ item.variant_name }}</p>
                  <p
                    class="mb-0 mr-0 text-left text-truncate caption"
                  >상품코드 : {{ item.product_code }}</p>
                  <p
                    class="mb-3 mr-0 text-left text-truncate caption"
                  >품목코드 : {{ item.variant_code }}</p>
                </v-col>
              </v-row>
            </template>
            <!--
            <template v-slot:item.activate_type="{ item }" class="pl-0 pr-0 ml-0 mr-0">
              <v-row no-gutters>
                <v-col :cols="11" class="pl-0 pr-0 ml-0 mr-0">
                  {{
                  item.activate_type | defaultString
                  }}
                </v-col>
              </v-row>
            </template>

            <template v-slot:item.duration_type="{ item }" class="pl-0 pr-0 ml-0 mr-0">
              <v-row no-gutters>
                <v-col :cols="11" class="pl-0 pr-0 ml-0 mr-0">
                  {{
                  item.duration_type | defaultString
                  }}
                </v-col>
              </v-row>
            </template>

            <template v-slot:item.duration="{ item }" class="pl-0 pr-0 ml-0 mr-0">
              <v-row no-gutters>
                <v-col :cols="11" class="pl-0 pr-0 ml-0 mr-0">
                  {{
                  item.duration | defaultString
                  }}
                </v-col>
              </v-row>
            </template>

            <template v-slot:item.number_of_serial="{ item }" class="pl-0 pr-0 ml-0 mr-0">
              <v-row no-gutters>
                <v-col :cols="11" class="pl-0 pr-0 ml-0 mr-0">
                  {{
                  item.number_of_serial | defaultString
                  }}
                </v-col>
              </v-row>
            </template>
            -->
            <template v-slot:item.error="{ item }" class="pl-0 pr-0 ml-0 mr-0">
              <v-row no-gutters>
                <v-col
                  :cols="11"
                  class="pl-0 pr-0 ml-0 mr-0"
                  style="color:rgb(192, 57, 43);"
                  v-html="$options.filters.excelErrorMessages(item.messages)"
                ></v-col>
              </v-row>
            </template>
            <template slot="no-data">
              <div class="noDataProductInfos">내역이 없습니다.</div>
            </template>
          </v-data-table>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>
<style scoped>
.noDataProductInfos {
  padding: 50px 0;
}
</style>
<script>
import M from "@/libs/mapping.js";
import Excel from "@/libs/excel.js";
import CommonMixin from "@/mixins/CommonMixin.js";
import Filters from "@/libs/authservice/filters.js";

export default {
  data() {
    return {
      M,
      styleSize: {
        width: "70px",
        height: "50px"
      },
      selectStyleSize: {
        width: "180px",
        height: "50px"
      },
      headersAddList: [
        {
          text: "상품명",
          align: "center",
          value: "productName",
          sortable: false,
          class: "ml-0 mr-0 pl-0 pr-0",
          width: 100
        },
        {
          text: "상품코드",
          align: "center",
          value: "productCode",
          sortable: false,
          class: "ml-0 mr-0 pl-0 pr-0",
          width: 100
        },
        {
          text: "판매가",
          align: "center",
          value: "sellPrice",
          sortable: false,
          class: "ml-0 mr-0 pl-0 pr-0",
          width: 100
        },
        {
          text: "공급사명",
          align: "center",
          value: "supplyName",
          sortable: false,
          class: "ml-0 mr-0 pl-0 pr-0",
          width: 100
        },
        {
          text: "제조사명",
          align: "center",
          value: "manufacturerName",
          sortable: false,
          class: "ml-0 mr-0 pl-0 pr-0",
          width: 100
        },
        {
          text: "브랜드명",
          align: "center",
          value: "brandName",
          sortable: false,
          class: "ml-0 mr-0 pl-0 pr-0",
          width: 100
        },
        {
          text: "상품이미지url",
          align: "center",
          value: "imageUrl",
          sortable: false,
          class: "ml-0 mr-0 pl-0 pr-0",
          width: 250
        },
        {
          text: "옵션명",
          align: "center",
          value: "optionName",
          sortable: false,
          class: "ml-0 mr-0 pl-0 pr-0",
          width: 100
        },
        {
          text: "옵션판매가",
          align: "center",
          value: "optionPrice",
          sortable: false,
          class: "ml-0 mr-0 pl-0 pr-0",
          width: 100
        },
        {
          text: "품목코드",
          align: "center",
          value: "variantCode",
          sortable: false,
          class: "ml-0 mr-0 pl-0 pr-0",
          width: 100
        },
        {
          text: "실패사유",
          align: "center",
          value: "error",
          sortable: false,
          class: "ml-0 mr-0 pl-0 pr-0",
          width: 250
        }
      ],
      excelFile: null,
      sheetHeaderTitle: {
        상품명: "productName",
        상품코드: "productCode",
        판매가: "sellPrice",
        공급사명: "supplyName",
        제조사명: "manufacturerName",
        브랜드명: "brandName",
        상품이미지url: "imageUrl",
        옵션명: "optionName",
        옵션판매가: "optionPrice",
        품목코드: "variantCode"
      },
      errorMsg: {
        productName: "상품명 오류",
        productCode: "상품코드 오류",
        sellPrice: "판매가 오류",
        supplyName: "공급사명 오류",
        manufacturerName: "제조사명 오류",
        brandName: "브랜드명 오류",
        imageUrl: "상품이미지url 오류",
        optionName: "옵션명 오류",
        optionPrice: "옵션판매가 오류",
        variantCode: "품목코드 오류"
      },
      send: {
        data: [],
        divisionData: [],
        dataTotalCount: 0,
        limit: 20,
        totalCount: 0,
        index: 0
      },
      sheet: {
        data: [],
        totalCount: 0
      },
      failSheetData: [],
      generateSerialsDialog: false
    };
  },
  mixins: [CommonMixin],
  props: ["duration"],
  filters: Filters,
  methods: {
    /**
     * 파일 읽기
     */
    readFile: async function() {
      let maxSize = 10 * 1024 * 1024;
      if (!this.excelFile) {
        this.alertShow("엑셀파일을 업로드해주세요");
        return false;
      }

      let fileSize = this.excelFile.size;
      if (fileSize > maxSize) {
        this.alertShow("엑셀파일 사이즈를 10MB 이내로 업로드해주세요.");
        return false;
      }

      let progressText =
        "입력한 상품의 정품 인증 코드가 발급중입니다.</br>잠시만 기다려 주세요.";
      this.circularProgressShow(progressText);
      let ProductExcel = new Excel(this.excelFile, this.sheetHeaderTitle);
      this.sheet.data = await ProductExcel.getJson();

      this.sheet.totalCount = this.sheet.data.length;
      if (this.sheet.totalCount === 0) {
        this.alertShow("엑셀파일에 업로드할 데이터가 없습니다.");
        this.circularProgressHide();
        return false;
      }
      this.execExcelUpload();
    },
    /**
     * 업로드실행준비
     */
    execExcelUpload: async function() {
      this.failSheetData = [];
      await this.checkSheetData();
      this.setSendData();
      this.progressUpload(0);
    },
    /**
     * 엑셀 데이터 체크
     */
    checkSheetData: async function() {
      for (let i = 0; i < this.sheet.totalCount; i++) {
        let prd = this.sheet.data[i];
        prd["messages"] = [];
        await this.issetCheck(prd)
          .catch(this.addFailData)
          .then(prd => {
            if (prd !== undefined) {
              this.send.data.push(prd);
            }
          });
      }
      this.send.dataTotalCount = this.send.data.length;
    },

    issetCheck: function(prd) {
      let $this = this;
      return new Promise(function(resolve, reject) {
        let checkTitle = ["productName", "sellPrice"];
        checkTitle.forEach(key => {
          let hasKey = Object.prototype.hasOwnProperty.call(prd, key);
          if (!hasKey) {
            prd["messages"].push($this.errorMsg[key]);
            reject(prd);
            return false;
          }
        });
        resolve(prd);
      });
    },
    /**
     * 실패한 상품 데이터
     */
    addFailData: function(data) {
      this.failSheetData.push(data);
    },
    /**
     * 전송 데이터 셋팅
     */
    setSendData: function() {
      this.send.divisionData = [];
      this.send.totalCount = Math.floor(
        this.send.dataTotalCount / this.send.limit
      );
      for (var i = 0; i <= this.send.totalCount; i++) {
        this.send.divisionData.push(this.send.data.splice(0, this.send.limit));
      }
    },
    /**
     * 엑셀 업로드 진행
     */
    progressUpload: async function(index) {
      this.circularProgressSetValue(
        Math.round((index / this.send.totalCount) * 100)
      );
      if (index > this.send.totalCount) {
        setTimeout(() => {
          this.circularProgressHide();
          if (this.sheet.totalCount - this.failSheetData.length > 0) {
            this.generateSerialsDialog = true;
          }
        }, 1000);
        return false;
      }
      await this.sendExcelData(index);
    },
    /**
     * 데이터 전송
     */
    sendExcelData: async function(index) {
      if (this.send.divisionData[index].length === 0) {
        index++;
        await this.progressUpload(index);
        return false;
      }

      let apiParams = [];

      for (let i = 0; i < this.send.divisionData[index].length; i++) {
        this.send.divisionData[index][i];
        let variant_list = [];
        variant_list.push({
          variant_name: this.send.divisionData[index][i].optionName,
          variant_code: this.send.divisionData[index][i].variantCode,
          variant_price: this.send.divisionData[index][i].optionPrice
        });

        let apiParamsData = {
          imageurl: this.send.divisionData[index][i].imageUrl,
          product_name: this.send.divisionData[index][i].productName,
          product_code: this.send.divisionData[index][i].productCode,
          product_price: this.send.divisionData[index][i].sellPrice,
          vendor_name: this.send.divisionData[index][i].supplyName,
          manufacturer_name: this.send.divisionData[index][i].manufacturerName,
          brand_name: this.send.divisionData[index][i].brandName,
          variant_list: variant_list
        };
        apiParams.push(apiParamsData);
      }

      try {
        let res = await M.api(
          M.entry("/api/cert/partners/products/excel"),
          apiParams
        );

        for (let m = 0; m < res.length; m++) {
          if (!res[m].product_no || res[m].product_no < 0) {
            let failData = {
              imageUrl: res[m].image_url,
              productName: res[m].product_name,
              productCode: res[m].product_code,
              sellPrice: res[m].product_price,
              supplyName: res[m].vendor_name,
              manufacturerName: res[m].manufacturer_name,
              brandName: res[m].brand_name,
              messages: Array("등록실패"),
              optionName: res[m].variant_name,
              variantCode: res[m].variant_code,
              optionPrice: res[m].variant_price
            };
            this.addFailData(failData);
          }
        }

        if (this.failSheetData.length == 0) {
          this.alertShow("업로드 되었습니다");
        }
      } catch (e) {
        this.send.divisionData[index].forEach(prd => {
          prd["messages"].push("API 에러");
          this.addFailData(prd);
        });
      }
      index++;
      await this.progressUpload(index);
    },
    /**
     * 파일다운
     */
    excelSampleDownLoad: function() {
      var url =
        "/shoplus_authservice/etc/sample/정품인증서비스_상품등록_엑셀업로드양식.xlsx";
      location.href = url;
    }
  }
};
</script>
